import React, { useCallback, useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import Navbar from '../../layout/Navbar/Navbar';
import Sidebar from '../../layout/Sidebar/SideBar';
import Loading from '../../components/Loading';


import blogFetch from '../../axios/config';
import './style.css';
import { HistoricoTelasI, Ordem, TipoTela } from './types';
import { InfoCard } from './InforCard';
import { DataTable } from './DataTable';
import { CriarTelaModal } from './CriatTelaModal';
import * as XLSX from "xlsx";
import fs from 'fs';
import { CriarModalOrdens } from './CriarModalOrdens';


export default function Fotolito() {
	const [ordens, setOrdens] = useState<Ordem[]>([]);
	const [historicoTelas, setHistoricoTelas] = useState<HistoricoTelasI[]>([]);
	const [tipoTela, setTipoTela] = useState<TipoTela>('');
	const [quantidade, setQuantidade] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openModalOrdens, setOpenModalOrdens] = useState(false);
	const [ordensSoltas, setOrdensSoltas] = useState([])




	const fetchData = async() => {
		try {
			setIsLoading(true);
			const { data } = await blogFetch.get<Ordem[]>("SAGA_ListaProducao/getOrdens");

			console.log(data);

			setOrdens(data);
		} catch (error) {
			console.error("Erro ao buscar ordens:", error);
		} finally {
			setIsLoading(false);
		}
	}

	const fetchHistorico = async() => {
		try {
			setIsLoading(true);
			const { data } = await blogFetch.get<HistoricoTelasI[]>(
				"SAGA_ListaProducao/getHistoricoTelas"
			);
			setHistoricoTelas(data);
		} catch (error) {
			console.error("Erro ao buscar histórico:", error);
		} finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {

		fetchData();
		fetchHistorico();
	}, []);

	const handleSubmit = useCallback((e: React.FormEvent) => {
		e.preventDefault();
		blogFetch.post(`SAGA_ListaProducao/criarImpressaoTelas?tipo=${tipoTela}`, user.user_UserName, {
			responseType: 'blob' // Isso informa ao Axios que a resposta é um blob
		})
			.then(response => {
				if (response.data) {
					const blob = new Blob([response.data]);
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'Telas.xlsx';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);
				}

				fetchData()
				fetchHistorico()
			})
			.catch(error => {
				console.error('Erro ao baixar o arquivo:', error);
			});

		setShowModal(false);
		setTipoTela('');
		setQuantidade('');
		fetchData()
		fetchHistorico()
	}, [tipoTela, quantidade]);

	const ordensColumns = [
		{ key: 'ordem_Fabric', header: 'Ordem' },
		{ key: 'serial', header: 'Serial' },
		{ key: 'caracteristica_Resultado', header: 'Característica' }
	];

	const historicoColumns = [
		{ key: 'imp_Tela', header: 'Tela' },
		{ key: 'imp_Ordem', header: 'Ordem' },
		{ key: 'imp_CodLote', header: 'Lote' },
		{ key: 'imp_Status', header: 'Status' },
		{
			key: '_ts_Creat',
			header: 'Data',
			render: (item: HistoricoTelasI) => new Date(item._ts_Creat).toLocaleDateString()
		}
	];

	const user = JSON.parse(localStorage.getItem('user') as string);

	console.log(user)


	const openModalListaOrdens = async () => {
		const { data } = await blogFetch.get('SAGA_ListaProducao/getOrdensSolta')
		setOrdensSoltas(data);
		setOpenModalOrdens(true)
	}

	const handleReimprimir = (e: React.FormEvent) => {
		e.preventDefault()

		blogFetch.post(`SAGA_ListaProducao/ReimprimirOrdensSoltas`, ordensSoltas, {
			responseType: 'blob' // Isso informa ao Axios que a resposta é um blob
		})
			.then(response => {
				if (response.data) {
					const blob = new Blob([response.data]);
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'TelasSoltas.xlsx';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);
					setOrdensSoltas([])
					setOpenModalOrdens(false)
				}

				fetchData()
				fetchHistorico()

			})
			.catch(error => {
				console.error('Erro ao baixar o arquivo:', error);
			});
	}

	return (
		<>
			<Navbar />
			<Sidebar />
			<Container fluid className="app_body">
				{!isLoading ? (
					<>
						<div className="_telascard-container">

							<InfoCard
								title="Lista de Ordens"
								actionButton={<Button
									variant="primary"
									onClick={() => setShowModal(true)}
									className="generate-btn"
								>
									Gerar Tela
								</Button>
								}
							>
								<DataTable
									data={ordens}
									columns={ordensColumns}
									isLoading={isLoading}
									emptyMessage="Nenhuma ordem encontrada" />
							</InfoCard>

							<InfoCard title="Histórico de Telas" actionButton={<Button
								variant="primary"
								onClick={() => openModalListaOrdens()}
								className="generate-btn"
							>
								Telas Soltas
							</Button>
							} >

								<DataTable
									data={historicoTelas}
									columns={historicoColumns}
									isLoading={isLoading}
									emptyMessage="Nenhuma tela encontrada"
								/>
							</InfoCard>
							<CriarTelaModal
								show={showModal}
								onHide={() => setShowModal(false)}
								onSubmit={handleSubmit}
								tipoTela={tipoTela}
								setTipoTela={setTipoTela}
								quantidade={quantidade}
								setQuantidade={setQuantidade}
							/>

							<CriarModalOrdens
								show={openModalOrdens}
								onHide={() => setOpenModalOrdens(false)}
								onSubmit={handleReimprimir}
								ordensSoltas={ordensSoltas}
							/>
						</div>
					</>
				) : <Loading />}

			</Container>
		</>
	);
}